import { apiRequest } from "../apiRequest";

export const fetchUserStastistics = () =>
    apiRequest("/users/statistics", "GET");

export const getUserReserve = () =>
    apiRequest("/accounting/user/reserve", "GET");
